import React from 'react';
import { useDispatch } from 'react-redux'
import GerberFile from 'pu-react/components/GerberFileFC';
import { processFile as processZipFile } from 'product_tabs/tab_parts/slice/process_file';

const tooltip = `Please include in the Zip File:
- BOM
- XY Data
- Assembly Drawings (If available)
- Assembly Notes (if available)`;

const ZipFile = ({ label, text, parameters, onChangeParameter, validator }) => {
  const dispatch = useDispatch();

  const processFile = (file) => {
    dispatch(processZipFile(file))
  }
  return (
    <GerberFile
      parameters={parameters}
      onChangeParameter={onChangeParameter}
      processFile={processFile}
      label={label}
      text={text}
      tooltip={tooltip}
      errorMessage={validator.message('Zip file', parameters.filename, 'required')} />
  )
};

export default ZipFile;
